class CustomReview extends HTMLElement {
    constructor() {
        super();

        if (this.querySelector('.swiper-custom-review')) {
            this.swiper = new Swiper(this.querySelector('.swiper-custom-review'), {
                // Optional parameters
                direction: 'horizontal',
                slidesPerView: 'auto',

                loop: true,
                pagination: {
                    el: this.querySelector('.swiper-pagination'),
                },

            });
        }

        this.updateHeightContent();
        window.addEventListener('resize', this.updateHeightContent.bind(this))
    }

    updateHeightContent() {
        const maxHeight = [];

        this.querySelectorAll('.review-slide__content').forEach((item) => {
            item.style.minHeight = 'unset';
            maxHeight.push(item.offsetHeight);
        })

        this.querySelectorAll('.review-slide__content').forEach((item) => {
            item.style.minHeight = `${Math.max(...maxHeight)}px`;

        })

    }
}

customElements.define('custom-review', CustomReview);